import type { BrandSite } from "./brand-site-api";

/** 列表卡片用的展示字段：绑域优先，否则平台临时域名 */
export function brandSiteDisplayHost(
  site: Pick<BrandSite, "custom_host" | "public_url" | "slug">,
): string {
  const custom = site.custom_host?.trim();
  if (custom) return custom.replace(/^https?:\/\//i, "").replace(/\/.*$/, "");

  const publicUrl = site.public_url?.trim();
  if (publicUrl) {
    try {
      const url = new URL(publicUrl.includes("://") ? publicUrl : `https://${publicUrl}`);
      return url.port && url.port !== "443" && url.port !== "80"
        ? `${url.hostname}:${url.port}`
        : url.hostname;
    } catch {
      return publicUrl.replace(/^https?:\/\//i, "").replace(/\/.*$/, "");
    }
  }

  const slug = site.slug?.trim();
  return slug ? `${slug}.web.c456.com` : "尚未分配";
}

export function brandSiteVersionLabel(site: Pick<BrandSite, "current_release">): string {
  const number = site.current_release?.number;
  if (number == null) return "尚未发布";
  return `第 ${number} 版`;
}

export function formatBrandSiteDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function formatBrandSiteDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}
